import type { Account } from '@/api/generated/model';
import type { NetWorthHistory } from '@/features/accounts';
import { NetWorthTrendCard } from './NetWorthTrendCard';

interface NetWorthTrendCardLazyProps {
  data: NetWorthHistory[];
  selectedAccount?: Account | null;
  isLoading?: boolean;
}

/** Deferred chart entry point — recharts loads with the parent route chunk, not a nested lazy boundary. */
export function NetWorthTrendCardLazy(props: NetWorthTrendCardLazyProps) {
  return <NetWorthTrendCard {...props} />;
}
